// @flow
import { DeviceInfoPanelHeading, DeviceInfoPanelList, DeviceInfoPanelListItem, DeviceInfoPanelValue } from './styles';
import type { DevicePanelInfoProps, FormProps } from './types';

import EditDeviceName from './edit-device-name';
import { FormattedMessage } from 'react-intl';
import messages from '../intl';
import * as React from 'react';
import TimeSpan from '../../timespan';

type Props = FormProps & DevicePanelInfoProps;

const HubInfoPanelList = ({
    ipAddress,
    macAddress,
    version,
    lastSeen,
    power,
    connection,
    deviceName,
    fields,
    headingIntl
}: Props) => (
    <DeviceInfoPanelList>
        <EditDeviceName deviceName={deviceName} fields={fields} headingIntl={headingIntl} />
        <DeviceInfoPanelListItem>
            <DeviceInfoPanelHeading>
                <FormattedMessage {...messages.powerSource} />:
            </DeviceInfoPanelHeading>
            <DeviceInfoPanelValue>
                <FormattedMessage {...messages[power]} />
            </DeviceInfoPanelValue>
        </DeviceInfoPanelListItem>
        <DeviceInfoPanelListItem>
            <DeviceInfoPanelHeading>
                <FormattedMessage {...messages.internetConnection} />
                :
            </DeviceInfoPanelHeading>
            <DeviceInfoPanelValue>
                <FormattedMessage {...messages[connection]} />
            </DeviceInfoPanelValue>
        </DeviceInfoPanelListItem>
        <DeviceInfoPanelListItem>
            <DeviceInfoPanelHeading>
                <FormattedMessage {...messages.ipAddress} />:
            </DeviceInfoPanelHeading>
            <DeviceInfoPanelValue>{ipAddress}</DeviceInfoPanelValue>
        </DeviceInfoPanelListItem>
        {macAddress && (
            <DeviceInfoPanelListItem>
                <DeviceInfoPanelHeading>
                    <FormattedMessage {...messages.macAddress} />:
                </DeviceInfoPanelHeading>
                <DeviceInfoPanelValue>{macAddress}</DeviceInfoPanelValue>
            </DeviceInfoPanelListItem>
        )}
        <DeviceInfoPanelListItem>
            <DeviceInfoPanelHeading>
                <FormattedMessage {...messages.firmwareVersion} />
                :
            </DeviceInfoPanelHeading>
            <DeviceInfoPanelValue>{version}</DeviceInfoPanelValue>
        </DeviceInfoPanelListItem>
        <DeviceInfoPanelListItem>
            <DeviceInfoPanelHeading>
                <FormattedMessage {...messages.hubUptime} />:
            </DeviceInfoPanelHeading>
            <DeviceInfoPanelValue>
                <TimeSpan value={lastSeen} />
            </DeviceInfoPanelValue>
        </DeviceInfoPanelListItem>
    </DeviceInfoPanelList>
);

export default HubInfoPanelList;



// WEBPACK FOOTER //
// ./src/components/widgets/device-info-panel/panel-list/hub.js